// Solar battery level ranges and details for use in the application
// Source: KSPL_SmartLid_Feature_Range specifications (see screenshot)

// Water tank level ranges and colors for mobile application
export const WATER_TANK_LEVEL_RANGES = [
  {
    min: 80,
    max: 100,
    rangeName: 'Optimal Range',
    label: 'Tank Full',
    color: '#6EA84D', // AEROCON
    icon: 'check',
  },
  {
    min: 60,
    max: 80,
    rangeName: 'Healthy Range',
    label: '3/4 Tank',
    color: '#6EA84D', // AEROCON
    icon: 'circle',
  },
  {
    min: 40,
    max: 60,
    rangeName: 'Moderate Range',
    label: 'Half Tank',
    color: '#FFD530', // CHARMINAR
    icon: 'circle',
  },
  {
    min: 20,
    max: 40,
    rangeName: 'Low Range',
    label: '1/4 Tank',
    color: '#FF7700', // ORANGE
    icon: 'circle',
  },
  {
    min: 0,
    max: 20,
    rangeName: 'Critical Range',
    label: 'Tank Empty',
    color: '#D7184d', // RED
    icon: 'triangle',
  },
];

export const SOLAR_BATTERY_LEVEL_RANGES = [
  {
    min: 80,
    max: 100,
    rangeName: 'Optimal Range',
    label: 'Excellent',
    color: '#6EA84D',
    colorName: 'AEROCON',
    impact: 'Full power available for uninterrupted operation.',
    action: 'Maintain. Clean panels, monitor usage.',
  },
  {
    min: 60,
    max: 80,
    rangeName: 'Healthy Range',
    label: 'Good',
    color: '#6EA84D',
    colorName: 'AEROCON',
    impact: 'Reliable performance with no functional issues.',
    action: 'Monitor trends. Check for shading or dust.',
  },
  {
    min: 40,
    max: 60,
    rangeName: 'Moderate Range',
    label: 'Fair',
    color: '#FFD530',
    colorName: 'CHARMINAR',
    impact: 'Backup capacity is limited. Risk of power issues on cloudy days.',
    action: 'Consider reducing load or charging earlier.',
  },
  {
    min: 20,
    max: 40,
    rangeName: 'Low Range',
    label: 'Low',
    color: '#FF7700',
    colorName: 'ORANGE',
    impact: 'Backup power is low. May not work properly when needed.',
    action: 'Investigate cause. Delay non-critical usage.',
  },
  {
    min: 0,
    max: 20,
    rangeName: 'Critical Range',
    label: 'Critical',
    color: '#D7184d',
    colorName: 'RED',
    impact:
      'Battery nearly drained. Permanent damage risk if deep discharge continues.',
    action: 'Shut down load. Recharge immediately.',
  },
];

export const WATER_TEMPERATURE_RANGES = [
  {
    min: -Infinity,
    max: 10,
    label: 'Too Cold',
    color: '#007AB2',
    colorName: 'RED',
    remarks:
      'Rare in India; may cause discomfort in bathing and slow appliance efficiency.',
  },
  {
    min: 10,
    max: 20,
    label: 'Ideal',
    color: '#6EA84D',
    colorName: 'AEROCON',
    remarks: 'Best for drinking and bathing.',
  },
  {
    min: 20,
    max: 30,
    label: 'Acceptable',
    color: '#6EA84D',
    colorName: 'AEROCON',
    remarks: 'Safe but may feel warm in summer.',
  },
  {
    min: 30,
    max: 40,
    label: 'Moderate',
    color: '#FFD530',
    colorName: 'CHARMINAR',
    remarks: 'Can promote microbial growth. Not ideal for drinking.',
  },
  {
    min: 40,
    max: Infinity,
    label: 'High',
    color: '#D7184d',
    colorName: 'RED',
    remarks:
      'Risk of bacterial proliferation, algae, and discomfort. May damage plumbing.',
  },
];

export const TDS_RANGES = [
  {
    min: -Infinity,
    max: 50,
    quality: 'Poor',
    label: 'Worst',
    color: '#D7184d',
    colorName: 'RED',
    remarks:
      'Too pure; lacks essential minerals. Tastes flat and may leach toxins from pipes.',
    userText: 'Water has very low mineral content, not ideal for drinking.',
  },
  {
    min: 50,
    max: 150,
    quality: 'Excellent',
    label: 'Best',
    color: '#6EA84D',
    colorName: 'AEROCON',
    remarks: 'Ideal for RO-purified water. Balanced minerals and taste.',
    userText: 'Safe and good for consumption.',
  },
  {
    min: 150,
    max: 250,
    quality: 'Good',
    label: 'Good',
    color: '#6EA84D',
    colorName: 'AEROCON',
    remarks: 'Still healthy; preferred for cardiovascular health.',
    userText: 'Safe and good for consumption.',
  },
  {
    min: 250,
    max: 350,
    quality: 'Acceptable',
    label: 'Fair',
    color: '#6EA84D',
    colorName: 'AEROCON',
    remarks: 'Common in Indian households; decent taste.',
    userText: 'Water is ok for consumption, but may taste slightly different.',
  },
  {
    min: 350,
    max: 500,
    quality: 'Borderline',
    label: 'Average',
    color: '#FFD530',
    colorName: 'CHARMINAR',
    remarks: 'May need RO filtration; taste and health impact vary.',
    userText: 'Water quality is poor—not recommended for consumption.',
  },
  {
    min: 500,
    max: 900,
    quality: 'Poor',
    label: 'Poor',
    color: '#FF7700',
    colorName: 'ORANGE',
    remarks: 'Not recommended for drinking without treatment.',
    userText: 'TDS is above acceptable range, consider water solutions.',
  },
  {
    min: 900,
    max: 1200,
    quality: 'Very Poor',
    label: 'Very Poor',
    color: '#D7184d',
    colorName: 'RED',
    remarks: 'Avoid if possible; may harm kidneys and taste unpleasant.',
    userText: 'Water unsafe for consumption—use only if treated/filtered.',
  },
  {
    min: 1200,
    max: Infinity,
    quality: 'Unacceptable',
    label: 'Worst',
    color: '#D7184d',
    colorName: 'RED',
    remarks: 'Unsafe for consumption; needs urgent treatment.',
    userText: 'Water is unsafe for consumption.',
  },
];
